import { render, staticRenderFns } from "./NoticePage.vue?vue&type=template&id=0e064bac&scoped=true&"
import script from "./NoticePage.vue?vue&type=script&lang=ts&"
export * from "./NoticePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e064bac",
  null
  
)

export default component.exports